import React from 'react';

interface SuccessModalProps {
  successData: any;
  onClose: () => void;
  onViewBuyBack: () => void;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({
  successData,
  onClose,
  onViewBuyBack,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg p-5 sm:p-6 md:p-8 max-w-md w-full mx-2 sm:mx-4 max-h-[90vh] overflow-y-auto">
        <div className="text-center">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">🎉 Swap Successful!</h3>
          <p className="text-sm  text-gray-300 mb-5 sm:mb-6 px-2">
            {successData.successCount && successData.totalTokens ?
              `Successfully swapped ${successData.successCount} out of ${successData.totalTokens} tokens!` :
              'You\'ve successfully swapped your selected tokens!'
            }
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-2 sm:gap-3">
            <button
              onClick={onClose}
              className="w-full sm:w-auto px-6 sm:px-8 py-2.5 sm:py-3 bg-green-600 hover:bg-green-700 active:bg-green-800 rounded-lg text-white text-sm  font-medium min-h-[48px] sm:min-h-[44px] transition-colors"
            >
              Continue
            </button>
            <button
              onClick={onViewBuyBack}
              className="w-full sm:w-auto px-6 sm:px-8 py-2.5 sm:py-3 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-lg text-white text-sm  font-medium min-h-[48px] sm:min-h-[44px] transition-colors"
            >
              View BuyBack
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

